import { Preview } from "@mui/icons-material";
import { doc, getDoc } from "firebase/firestore";
import { useEffect, useRef, useState } from "react";
import { getLocalStorageItem } from "../../../../controllers/localStorage/getLocalStorage";
import getSettings from "../../../../controllers/settings/getSettings";
import { db } from "../../../../firebase";
import { getEmailTemplates } from "../../Controller/getTemplates";
import "./Design.css";
import parse from "html-react-parser";
import FormatPriceNumeral from "../../../../helpers/FormatPriceNumeral";
import FormatPriceVerbal from "../../../../helpers/FormatPriceVerbal";

import RefreshIcon from "@mui/icons-material/Refresh";
import NoDataFound from "../../../../components/Common/NoDataFound/NoDataFound";
const Design = ({
  template,
  setTemplate,
  templateError,
  setTemplateError,
  getCampaignSource,
  property,
  setTemplateHtml,
  templateHtml,
}) => {
  const [allEmailTemplates, setAllEmailTemplates] = useState([]);
  const [bDetails, setBDetails] = useState({});
  const [mCurrencySettings, setMCurrencySettings] = useState({});
  const [refresh, setRefresh] = useState(true);
  const [isRefreshing, setIsRefreshing] = useState(false);

  const Element = useRef();

  const setHtml = () => {
    if (templateHtml !== "") {
      let temp = "";
      temp = templateHtml;
      let price =
        mCurrencySettings.currency + mCurrencySettings.currencyFormat ===
        "numeral"
          ? property?.rentalPrice > 0
            ? FormatPriceNumeral(property?.rentalPrice)
            : FormatPriceNumeral(property?.sellingPrice)
          : property?.rentalPrice > 0
          ? FormatPriceVerbal(property?.rentalPrice)
          : FormatPriceVerbal(property?.sellingPrice);
      temp = temp.replace("Property Name", property?.propertyTitle);
      temp = temp.replace("Property Price", price);
      temp = temp.replace("Property Address", property?.propertyTitle);
      temp = temp.replace("Property City", property?.city);
      temp = temp.replace("Property Description", property?.description);
      temp = temp.replace(
        "https://firebasestorage.googleapis.com/v0/b/landbook-qa.appspot.com/o/sample_images%2Farchitecture-5339245__340.jpg?alt=media&token=96c5674b-2a5b-498f-b375-c757eaf1844c",
        property?.property?.images?.length > 0
          ? "'" + `"${property?.images[0]}"` + "'"
          : "https://firebasestorage.googleapis.com/v0/b/landbook-qa.appspot.com/o/sample_images%2Farchitecture-5339245__340.jpg?alt=media&token=96c5674b-2a5b-498f-b375-c757eaf1844c"
      );
      temp = temp.replace(
        "https://firebasestorage.googleapis.com/v0/b/landbook-qa.appspot.com/o/sample_images%2Fyour%20logo.png?alt=media&token=55e199c0-a3b3-4ae3-b758-65799820df8b",

        bDetails?.image_url
          ? `"${bDetails?.image_url}"`
          : "https://firebasestorage.googleapis.com/v0/b/landbook-qa.appspot.com/o/sample_images%2Fyour%20logo.png?alt=media&token=55e199c0-a3b3-4ae3-b758-65799820df8b"
      );
      console.log("temp temp temp: ", temp);
      setTemplateHtml(temp);
    }
  };

  useEffect(() => {
    if (template != null) {
      setTemplateHtml(template.html);
      setHtml();
    }
  }, []);

  useEffect(() => {
    async function fetchData() {
      const clientDocument = await doc(
        db,
        "clients",
        getLocalStorageItem("bid")
      );
      const clientSnapshot = await getDoc(clientDocument);
      const client = { id: clientSnapshot.id, ...clientSnapshot.data() };
      setBDetails(client);
    }
    fetchData();
  }, []);
  const options = {
    replace: ({ attribs }) => {
      if (!attribs) {
        return;
      }

      if (attribs.id === "PropertyName") {
        return <span id="PropertyName"> {property?.propertyTitle}</span>;
      }
      if (attribs.id === "PropertyPrice") {
        return (
          <span id="PropertyPrice">
            {mCurrencySettings.currency}
            {`
              ${
                mCurrencySettings.currencyFormat === "numeral"
                  ? property?.rentalPrice > 0
                    ? FormatPriceNumeral(property?.rentalPrice)
                    : FormatPriceNumeral(property?.sellingPrice)
                  : property?.rentalPrice > 0
                  ? FormatPriceVerbal(property?.rentalPrice)
                  : FormatPriceVerbal(property?.sellingPrice)
              }`}
          </span>
        );
      }
      if (attribs.id === "PropertyAddress") {
        return <span id="PropertyAddress"> {property?.propertyTitle}</span>;
      }
      if (attribs.id === "PropertyCity") {
        return <span id="PropertyCity"> {property?.city}</span>;
      }
      if (attribs.id === "PropertyDescription") {
        return (
          <span id="PropertyDescription">
            {property?.description?.length > 100
              ? property?.description?.slice(0, 100) + "...."
              : property?.description}
          </span>
        );
      }
      if (attribs.id === "propertyImage") {
        return (
          <img
            id="propertyImage property-img-email"
            class="adapt-img"
            src={
              property?.images?.length > 0
                ? property?.images[0]
                : `https://actdwm.stripocdn.email/content/guids/CABINET_a5ab9a577b8b948a7d2025679ccd1afe386319fac48ed8002beb9f53098ca24b/images/architecture5339245__340.jpg`
            }
            width="200"
            height="200"
          />
        );
      }
      if (attribs.id === "businessLogo") {
        return (
          <img
            class="adapt-img logo-img-email"
            id="businessLogo"
            src={
              bDetails?.image_url
                ? bDetails?.image_url
                : "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b6/Image_created_with_a_mobile_phone.png/220px-Image_created_with_a_mobile_phone.png"
            }
            width="50"
            height="50"
          />
        );
      }
    },
  };
  useEffect(async () => {
    setIsRefreshing(true);
    const emailsData = await getEmailTemplates();

    setAllEmailTemplates(emailsData);
    const settings = await getSettings();
    setMCurrencySettings(settings);
    setIsRefreshing(false);
  }, [refresh]);

  return (
    <div>
      <div className="select-template-container">
        <h4 className="marketing-design-heading">
          Select {getCampaignSource} template of your choice
        </h4>

        <div className="create-template-button-container">
          <a href="/user/marketing/template" target="_blank">
            Create Template
          </a>
          <button
            className="template-refresh-btn"
            onClick={() => {
              setRefresh(refresh === true ? false : true);
            }}
          >
            <RefreshIcon className={`${isRefreshing ? "refresh-icon" : ""}`} />{" "}
            Refresh
          </button>
        </div>
      </div>

      {templateError && (
        <label className="custom-error-message" htmlFor="text">
          Select template
        </label>
      )}

      {getCampaignSource == "WhatsApp" ? (
        <div className="slider-container mt-2">
          {allEmailTemplates.length > 0 ? (
            allEmailTemplates?.map((data, i) => {
              return (
                <div
                  className={`marketing-email-image parse-html-style ${
                    template !== null && data.id === template.id
                      ? "marketing-email-image-active"
                      : ""
                  }`}
                  onClick={() => {
                    setTemplateError(false);
                    setTemplate(allEmailTemplates[i]);
                  }}
                >
                  {parse(data.html, options)}
                </div>
              );
            })
          ) : (
            <NoDataFound />
          )}
        </div>
      ) : (
        <div className="slider-container">
          {allEmailTemplates.length > 0 ? (
            allEmailTemplates?.map((data, i) => {
              return (
                <div
                  className={`marketing-email-image parse-html-style ${
                    template !== null && data.id === template.id
                      ? "marketing-email-image-active"
                      : ""
                  }`}
                  onClick={() => {
                    console.log("templateHtml templateHtml", data.html);
                    setTemplateHtml(data.html);
                    setTemplateError(false);
                    setTemplate(allEmailTemplates[i]);
                    setHtml();
                  }}
                >
                  {parse(data.html, options)}
                </div>
              );
            })
          ) : (
            <div className="no-template-added">
              <NoDataFound />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Design;
